import { Component, OnInit, Inject, DOCUMENT } from '@angular/core';
import { AdvieswijzerService } from './advieswijzer.service';
import { BaseComponent } from '../components/base/base.component';
import { TextResourceService } from '../services/text-resource.service';
import { Question } from './models/question';
import { Suggestion } from './models/suggestion';
import { WindowRef } from '../services/window-ref.service';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { QuestionHistoryComponent } from './question-history/question-history.component';
import { QuestionListComponent } from './question-list/question-list.component';
import { SuggestionComponent } from './suggestion/suggestion.component';
import { PanelComponent } from '@cibg/ui-components';


@Component({
    selector: 'app-advieswijzer',
    templateUrl: './advieswijzer.component.html',
    imports: [QuestionHistoryComponent, QuestionListComponent, SuggestionComponent, PanelComponent]
})
export class AdvieswijzerComponent extends BaseComponent implements OnInit {
  showSuggestion = false;
  showMoreInfo = false;

  questions: Question[];
  suggestion: Suggestion;

  constructor(
    textResourceService: TextResourceService,
    private readonly windowRef: WindowRef,
    private readonly advieswijzerService: AdvieswijzerService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly title: Title,
    @Inject(DOCUMENT) private document: Document) {
    super(textResourceService, 'AdvieswijzerComponent');
  }

  ngOnInit() {
    const lang = this.activatedRoute.snapshot.data.lang;
    this.document.documentElement.lang = lang;
    this.title.setTitle(`${this.resources.websiteTitle} - ${this.resources.subsiteTitle}`);

    this.advieswijzerService.init(lang)
      .subscribe((questions) => {
        this.questions = questions;
        this.advieswijzerService.suggestionChanges
          .subscribe(suggestion => this.handleSuggestion(suggestion));
      });
  }

  private handleSuggestion(suggestion: Suggestion) {
    this.suggestion = suggestion;
    if (suggestion) {
      this.showSuggestion = true;
      this.showMoreInfo = suggestion.id !== 'suggestionUnfortunately';
      this.windowRef.scrollToElement('suggestion', false);
      suggestion.logPiwikEvent();
    } else {
      this.showSuggestion = false;
      this.showMoreInfo = false;
    }
  }
}
